import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getImageBaseUrl } from "../services/s3-utils";
import Upload from "antd/lib/upload";
import notification from "antd/lib/notification";
import { LoadingOutlined } from "@ant-design/icons";
import { UploadFile } from "../services/Utils";
import { updateUserInformation } from "../services/NewAuthService";

function UpdatePhoto({ fetchUser, isNew, setUploadDone, id, updatePhotoUrl }) {
  const [uploading, setUploading] = useState(false);
  const qalortUser = useSelector((state) => state.user.userData);

  const handleUpload = async (payload, path) => {
    if (uploading) {
      return;
    }
    setUploading(true);
    try {
      let response = await UploadFile(payload.file.originFileObj, {
        service: "users",
        access: "public-read",
        path: `/users/${qalortUser?.id || qalortUser?._id}/${path}/`,
      });
      await updateUserInformation({
        [path === "cover-photo" ? "cover" : "profile"]: response.data.data[0],
      });
      fetchUser();
      setUploading(false);
      updatePhotoUrl &&
        updatePhotoUrl({
          [path === "cover-photo" ? "cover" : "profile"]: response.data.data[0],
        });
      setUploadDone && setUploadDone(true);
      notification.success({
        description: "Profile photo successfully updated",
      });
    } catch (err) {
      notification.error({
        message:
          err.response?.data?.message || "An error occured. Please try again",
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center gap-2.5 sm:gap-6 flex-col sm:flex-row justify-center sm:justify-start mt-6 sm:mt-0 ">
      <img
        src={
          qalortUser?.profile ||
          qalortUser?.profile_image ||
          `${getImageBaseUrl}/assets/avatar.svg`
        }
        alt=""
        className="w-[100px] h-[100px] rounded-full profile_image"
      />

      <Upload
        fileList={null}
        multiple={false}
        onChange={(e) => handleUpload(e, "profile-photo")}
      >
        {isNew ? (
          <button
            data-testid="uploader"
            className={`bg-pri border-0 sm:border text-white text-sm py-2 px-5 sm:py-[7px] sm:px-6 flex items-center rounded-md font-medium`}
          >
            {uploading ? <LoadingOutlined /> : "Upload"}
          </button>
        ) : (
          <button
            id={id}
            className={`[@media(max-width:639px)]:bg-transparent bg-pri-tint-3 border-0 sm:border bg-white text-dark text-sm py-2 px-5 sm:py-[7px] sm:px-6 flex items-center rounded-md border-dark font-medium`}
          >
            {uploading ? <LoadingOutlined /> : "Edit Photo"}
          </button>
        )}
      </Upload>
    </div>
  );
}

export default UpdatePhoto;
